export default __webpack_public_path__ + "static/media/skovstykket-tenancy-10.8c0a6908.jpg";